
{
  "familyId": "TGL-GELD-TELLEN",
  "questions": [
    {
      "id": "TGL-GELD-TELLEN-001",
      "familyId": "TGL-GELD-TELLEN",
      "module": "TijdGeld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Hoeveel geld is dit in totaal?\n2 euro + 50 cent + 20 cent",
      "context": null,
      "options": ["€ 2,70", "€ 2,07", "€ 2,50", "€ 2,72"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"mode": "display", "targetCents": 270}}],
      "conceptId": "geld_tellen_euro_cent",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Tel alle bedragen op: 2 euro = 200 cent, 50 cent, 20 cent. Totaal: 200 + 50 + 20 = 270 cent = € 2,70.",
        "distractorExplanations": {
          "0": "Correct! 2 euro + 50 cent + 20 cent = € 2,70.",
          "1": "Fout: je hebt de cent-bedragen niet goed opgeteld. 50 + 20 = 70 cent, niet 7 cent. Totaal: € 2,70.",
          "2": "Fout: je bent de 20 cent vergeten. 2 euro + 50 cent + 20 cent = € 2,70.",
          "3": "Fout: controleer je optelling. 50 + 20 = 70, niet 72. Totaal: € 2,70."
        }
      }
    },
    {
      "id": "TGL-GELD-TELLEN-002",
      "familyId": "TGL-GELD-TELLEN",
      "module": "TijdGeld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Hoeveel cent is € 1,35?",
      "context": null,
      "options": ["135 cent", "13 cent", "1.350 cent", "35 cent"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"mode": "display", "targetCents": 135}}],
      "conceptId": "geld_euro_naar_cent",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "1 euro = 100 cent. Dus € 1,35 = 1 × 100 + 35 = 135 cent. De cijfers voor de komma zijn euro's (×100), de cijfers na de komma zijn centen.",
        "distractorExplanations": {
          "0": "Correct! € 1,35 = 135 cent (1 euro = 100 cent, plus 35 cent).",
          "1": "Fout: je bent de euro vergeten. 1 euro = 100 cent, plus 35 cent = 135 cent.",
          "2": "Fout: 1 euro = 100 cent, niet 1.000 cent. € 1,35 = 135 cent.",
          "3": "Fout: je bent de euro vergeten. 1 euro = 100 cent, plus 35 cent = 135 cent totaal."
        }
      }
    },
    {
      "id": "TGL-GELD-TELLEN-003",
      "familyId": "TGL-GELD-TELLEN",
      "module": "TijdGeld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Welke munten heb je nodig om precies € 0,85 te betalen?",
      "context": null,
      "options": [
        "1 × 50 cent + 1 × 20 cent + 1 × 10 cent + 1 × 5 cent",
        "1 × 50 cent + 1 × 30 cent + 1 × 5 cent",
        "2 × 50 cent - 15 cent",
        "8 × 10 cent + 1 × 5 cent"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"mode": "display", "targetCents": 85}}],
      "conceptId": "geld_munten_samenstellen",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "50 + 20 + 10 + 5 = 85 cent = € 0,85. Controleer: 50 cent + 20 cent = 70 cent, + 10 cent = 80 cent, + 5 cent = 85 cent. ✓",
        "distractorExplanations": {
          "0": "Correct! 50 + 20 + 10 + 5 = 85 cent.",
          "1": "Fout: er bestaat geen munt van 30 cent. De munten zijn: 1, 2, 5, 10, 20, 50 cent en 1, 2 euro.",
          "2": "Fout: je kunt geen munten 'aftrekken'. Je telt munten bij elkaar op.",
          "3": "Fout: 8 × 10 = 80 cent, + 5 cent = 85 cent. Dit klopt wiskundig, maar optie A is de meest efficiënte manier."
        }
      }
    },
    {
      "id": "TGL-GELD-TELLEN-004",
      "familyId": "TGL-GELD-TELLEN",
      "module": "TijdGeld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Hoeveel geld heeft Lena in totaal?\nZe heeft: 1 biljet van € 5, 2 munten van € 1 en 3 munten van 50 cent.",
      "context": null,
      "options": ["€ 8,50", "€ 7,50", "€ 9,00", "€ 8,00"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"mode": "display", "targetCents": 850}}],
      "conceptId": "geld_tellen_combinatie",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Tel op: € 5 + 2 × € 1 + 3 × € 0,50 = € 5 + € 2 + € 1,50 = € 8,50. Stap voor stap: 5 + 2 = 7, plus 3 × 0,50 = 1,50, totaal 7 + 1,50 = € 8,50.",
        "distractorExplanations": {
          "0": "Correct! € 5 + € 2 + € 1,50 = € 8,50.",
          "1": "Fout: je bent een euro vergeten. 2 × € 1 = € 2, niet € 1. Totaal: € 5 + € 2 + € 1,50 = € 8,50.",
          "2": "Fout: 3 × 50 cent = € 1,50, niet € 2. Totaal: € 5 + € 2 + € 1,50 = € 8,50.",
          "3": "Fout: je bent de 50 cent munten vergeten. 3 × 50 cent = € 1,50. Totaal: € 5 + € 2 + € 1,50 = € 8,50."
        }
      }
    },
    {
      "id": "TGL-GELD-TELLEN-005",
      "familyId": "TGL-GELD-TELLEN",
      "module": "TijdGeld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Welk bedrag is het grootst?",
      "context": null,
      "options": ["€ 3,25", "€ 3,05", "€ 2,99", "€ 3,20"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "geld_vergelijken",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Vergelijk de euro's eerst: € 3,25 en € 3,20 en € 3,05 zijn alle drie meer dan € 2,99. Van de drie-euro-bedragen: € 3,25 > € 3,20 > € 3,05. Dus € 3,25 is het grootst.",
        "distractorExplanations": {
          "0": "Correct! € 3,25 is het grootst: 25 cent > 20 cent > 5 cent.",
          "1": "Fout: € 3,05 heeft maar 5 cent na de komma. € 3,25 heeft 25 cent, dat is meer.",
          "2": "Fout: € 2,99 heeft maar 2 euro. De andere bedragen hebben 3 euro, dus die zijn groter.",
          "3": "Fout: € 3,20 heeft 20 cent na de komma. € 3,25 heeft 25 cent, dat is 5 cent meer."
        }
      }
    }
  ]
}
